import React from "react";

interface TabProps {
  id: string;
  label: string;
  count?: string | number;
}

interface TabItemProps {
  tabList: Partial<TabProps>[];
  activeTab: string;
  handleClick: (d: any) => void;
  hasCardStyles?: boolean;
  tabCountClass?: string;
}

const TabItems: React.FC<TabItemProps> = ({
  hasCardStyles = false,
  tabList = [],
  activeTab = "",
  handleClick = () => {},
  tabCountClass = "",
}) => {
  return (
    <>
      <div className={`${hasCardStyles ? "card py-2" : ""} mb-2 `}>
        <div
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "none",
          }}
        >
          <ul
            className={`nav nav-tabs border-bottom d-flex flex-nowrap pb-0 px-1 mb-0`}
            style={{ width: "max-content", minWidth: "100%" }}
          >
            {tabList?.map((tab) => (
              <li className="nav-item" key={tab.id}>
                <button
                  className={`nav-link border-0 fw-semibol ${
                    activeTab === tab.id
                      ? "active text-primary rounded-0 border-bottom border-primary fw-semibold"
                      : ""
                  }`}
                  onClick={() => handleClick(tab)}
                >
                  <div className={tabCountClass}>
                    {tab.label}
                    {(tab?.count || tab?.count == 0) && (
                      <div className="text-center">({tab.count})</div>
                    )}
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <style>{`
.tab-scroll-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.tab-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

.custom-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: max-content;
  min-width: 100%;
  margin: 0;
  padding: 0;
  list-style: none; 
}

.custom-tab-btn {
  position: relative;
  background: transparent;
  border: none;
  padding: 12px 18px;
  color: #6c757d;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.custom-tab-btn:hover {
  color: #f26522;
}

.custom-tab-btn::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background: #f26522;
  border-radius: 10px 10px 0 0;
  transform: scaleX(0);
  transition: transform 0.25s ease;
}

.custom-tab-btn.active {
  color: #f26522;
  font-weight: 600;
}

.custom-tab-btn.active::after {
  transform: scaleX(1);
}

.custom-tab-btn:focus {
  outline: none;
  box-shadow: none;
}

.tab-count {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
}

.custom-tab-btn.active .tab-count {
  color: #f26522;
}
}
`}</style>
      {/* <div className={`${hasCardStyles ? "card py-2" : ""} mb-2`}>
        <div className="tab-scroll-wrapper">
          <ul className="custom-tabs">
            {tabList?.map((tab) => (
              <li key={tab.id}>
                <button
                  type="button"
                  className={`custom-tab-btn ${
                    activeTab === tab.id ? "active" : ""
                  }`}
                  onClick={() => handleClick(tab)}
                >
                  <div className={tabCountClass}>
                    {tab.label}
                    {(tab.count || tab.count === 0) && (
                      <div className="tab-count">({tab.count})</div>
                    )}
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
    </>
  );
};

export default TabItems;
